// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid4 {
  margin-top: 40px;
}

.grid4 .table_header:nth-child(-n+3), .grid4 .table_small:nth-child(-n+3) {
  width: 20%;
}

.grid4 .table_header:nth-child(2), .grid4 .table_small:nth-child(2) {
  width: 30%;
}

.grid4 .table_header:nth-child(1), .grid4 .table_small:nth-child(1) {
  width: 50%;
}

.grid4 .table_small p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/budget-summary/budget-reassignment-view-modal/budget-reassignment-view-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AACA;EACI,UAAA;AAEJ;;AAAA;EACI,UAAA;AAGJ;;AADA;EACI,UAAA;AAIJ;;AADA;EACI,SAAA;AAIJ","sourcesContent":[".grid4{\r\n    margin-top: 40px;\r\n}\r\n.grid4 .table_header:nth-child(-n+3), .grid4 .table_small:nth-child(-n+3){\r\n    width: 20%;\r\n}\r\n.grid4 .table_header:nth-child(2), .grid4 .table_small:nth-child(2){\r\n    width: 30%;\r\n}\r\n.grid4 .table_header:nth-child(1), .grid4 .table_small:nth-child(1){\r\n    width: 50%;\r\n}\r\n\r\n.grid4 .table_small p{\r\n    margin: 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
